import { render, staticRenderFns } from "./OperationListWidget.vue?vue&type=template&id=35cde4ec&scoped=true&"
import script from "./OperationListWidget.vue?vue&type=script&lang=js&"
export * from "./OperationListWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cde4ec",
  null
  
)

export default component.exports